import { Dayjs } from 'dayjs'
import { Connection } from './connection'
import { AlbumPhoto, Clique, EgoObject, Pagination } from './topic'

export interface AuthUser {
  user: string
  password: string
  firstName: string
  lastName: string
  dob: Dayjs | null
  code: string
}

export interface CognitoUser {
  requestID: string
  userID: string
  userName: string
}

export interface Ego {
  sequenceID: string
  egoID: string
  photoFullURL: string
  photoAlbumURL: string
}

export interface EgoBasicInfo {
  cliqueCount: string
  connCount: string
  connListVisible: boolean
  contName: string
  containerCount: string
  dob: string
  egoCount: string
  egoCurrency: string
  firstName: string
  furnCount: string
  gender: string
  homeCount: string
  isConnection: boolean
  joinDate: string
  lastLogin: string
  lastName: string
  location: string
  loginCount: string
  mobileContID: string
  motto: string
  notifyConnReq: string
  phoneNumber: string
  profession: string
  profileContID: string
  profileCount: string
  profileCoverThumbURL: string
  profileCoverURL: string
  profilePicFullURL: string
  profilePicThumbURL: string
  profilePicURL: string
  reqIgnored: boolean
  reqReceived: boolean
  reqReceivedConnReqID: number
  reqSent: boolean
  reqSentConnReqID: number
  showConnCount: string
  snapshotContID: string
  subscriptionStatus: string
  topicCount: string
  userEmail: string
  userID: string
  userName: string
}

export interface ConnectionRecommendation {
  currentCount: number
  firstName: string
  lastName: string
  location: string
  motto: string
  profession: string
  profilePicURL: string
  userID: string
}

export interface ConnectionRequest {
  connReqID: string
  connReqStatus: string
  profileAlbumPic: string
  profilePic: string
  rFname: string
  rLname: string
  reqReceivedTime: string
  requestorID: string
  requesterName: string
}

export interface ContainerListPagination extends Pagination {
  containerCount: number
}

export interface Container {
  cliqueTypes: string[]
  cliques: Clique[]
  connections: Connection[]
  containerAssetURL: string
  containerCatID: string
  containerCatName: string
  containerCatThumbURL: string
  containerDesc: string
  containerID: string
  containerImageURL: string
  containerName: string
  containerThumbURL: string
  datePurchased: string
  isGifted: number
  isSystemProvided: string
  latestEgo: string
  ownerVisits: string
  photoCount: string
  photoSnippet: AlbumPhoto[]
  profilePicThumbURL: string
  totalComments: number
  totalDislikes: number
  totalLikes: number
  userID: string
  userName: string
  visibility: string
  visitorVisits: string
}

export interface ContainerDetails {
  containerAssetURL: string
  containerCatID: string
  containerCatName: string
  containerCatThumbURL: string
  containerID: string
  containerImageURL: string
  containerName: string
  containerThumbURL: string
  egoObjects: EgoObject[]
  userID: string
  userName: string
  visibility: string
}

export enum ConnListAction {
  FOLLOW = 0,
  ACCEPT_CONN_REQUEST = 1,
  REJECT_CONN_REQUEST = 2,
  BLOCK = 3,
  DISCONNECT = 4,
}
